'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import { getHsformattingSettings } from '../utils';
import { CANVAS_FONT_SIZE } from '../constants/toolbar';
import TinyMceFontSize from '../components/toolbar/TinyMceFontSize';
import { BLOCK_FONT_SIZE_FORMAT, FONT_SIZE_BLOCKS } from '../constants/hsformatting';
import { applyFontSize } from './utils';
import { i18nNameSpace, hsformattingConfig } from '../constants/hsformatting';
import { i18nWithNameSpace } from '../utils/i18n';
import { maybeGetComputedStyle } from '../utils/getComputedStyle';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = i18nWithNameSpace(i18nNameSpace);
const fontSizeSelectMenuItem = 'fontSizeSelectMenuItem';
function registerBlockFontSize({
  target: editor
}) {
  editor.formatter.register(BLOCK_FONT_SIZE_FORMAT, {
    selector: FONT_SIZE_BLOCKS.join(','),
    styles: {
      fontSize: '%value'
    }
  });
}
export function addFontSizeSelects(editor) {
  const fontSizes = getHsformattingSettings(editor.settings, hsformattingConfig.FONT_SIZE_FORMATS, []);
  const items = fontSizes.map(fontSize => {
    return {
      text: {
        raw: `${fontSize}px`
      },
      value: `${fontSize}px`
    };
  });
  editor.on('PreInit', registerBlockFontSize);
  editor.addCommand('hsFontSize', (command, {
    value
  }) => {
    applyFontSize(editor, value);
  });
  const getFormattingAttributes = ({
    element
  }) => {
    if (!element) {
      return {};
    }
    const computedStyle = maybeGetComputedStyle(editor.getWin(), element);
    const fontSize = computedStyle && computedStyle.fontSize;
    return {
      [CANVAS_FONT_SIZE]: fontSize
    };
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    getFormattingAttributes
  });
  tinymce.canvas.addButton(editor, CANVAS_FONT_SIZE, () => ({
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        [CANVAS_FONT_SIZE]: fontSize
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(TinyMceFontSize, Object.assign({
        editor: editor,
        placeholder: i18nKey(fontSizeSelectMenuItem),
        fontSizes: items.map(({
          text: {
            raw: text
          },
          value
        }) => ({
          text,
          value
        })),
        fontSize: fontSize
      }, rest));
    }
  }));
}